import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const mesesNombre = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

const GraficoVentasMensuales = ({ datos }) => {
  const [datosGrafico, setDatosGrafico] = useState({});

  const limpiarMonto = (valor) => {
    if (typeof valor !== "string") valor = String(valor);
    return parseFloat(valor.replace(/\$/g, "").replace(/,/g, "")) || 0;
  };

  useEffect(() => {
    const agrupado = {};

    datos.forEach((d) => {
      const fecha = new Date(d.fecha);
      const mes = fecha.getMonth(); // 0 = Enero
      const anio = fecha.getFullYear();
      const total = limpiarMonto(d.total);

      if (!agrupado[anio]) agrupado[anio] = new Array(12).fill(0);
      agrupado[anio][mes] += total;
    });

    setDatosGrafico(agrupado);
  }, [datos]);

  const anios = Object.keys(datosGrafico).sort();
  const chartData = {
    labels: mesesNombre,
    datasets: anios.map((anio, i) => ({
      label: anio,
      data: datosGrafico[anio],
      backgroundColor: `hsl(${(i * 80) % 360}, 60%, 60%)`
    }))
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const value = ctx.raw || 0;
            return `$${value.toLocaleString("es-CL")}`;
          }
        }
      }
    },
    scales: {
      y: {
        ticks: {
          callback: (value) => `$${value.toLocaleString("es-CL")}`
        }
      }
    }
  };

  return (
    <div style={{ height: "300px", width: "100%" }}>
      <h5 className="text-center mb-3">Ventas por Mes y Año</h5>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default GraficoVentasMensuales;
